import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { daysUntil } from "@/utils/datetime";
export function getAttentionItems(backups, now) {
    const items = [];
    for (const b of backups) {
        if (b.status === "failed") {
            items.push({ backupId: b.id, email: b.target_email, type: "failed", label: "Backup eșuat" });
        }
        else if (b.is_stuck) {
            items.push({ backupId: b.id, email: b.target_email, type: "stuck", label: "Blocat" });
        }
        else if (b.retention_until && b.status !== "deleted") {
            const days = daysUntil(b.retention_until, now);
            if (days !== null && days >= 0 && days <= 7) {
                items.push({
                    backupId: b.id,
                    email: b.target_email,
                    type: "expiring",
                    label: days === 0 ? "Expiră azi" : `Expiră în ${days}z`,
                });
            }
        }
    }
    return items;
}
const BADGE_CLS = {
    failed: "bg-red-100 text-red-700",
    stuck: "bg-orange-100 text-orange-700",
    expiring: "bg-amber-100 text-amber-700",
};
const BADGE_LABEL = {
    failed: "Eșuat",
    stuck: "Blocat",
    expiring: "Expiră",
};
export function AttentionPanel({ backups }) {
    const navigate = useNavigate();
    const items = getAttentionItems(backups);
    if (items.length === 0)
        return null;
    return (_jsxs("div", { className: "rounded-lg border border-amber-200 bg-amber-50", children: [_jsx("div", { className: "border-b border-amber-200 px-4 py-3", children: _jsx("h2", { className: "text-xs font-semibold uppercase tracking-wide text-amber-800", children: "\u26A0 Necesit\u0103 aten\u021Bie" }) }), _jsx("div", { className: "grid grid-cols-1 gap-3 p-4 sm:grid-cols-2 lg:grid-cols-3", children: items.map((item) => (_jsxs("div", { onClick: () => navigate(`/backups/${item.backupId}`), className: "flex cursor-pointer items-center justify-between rounded-md border border-amber-200 bg-white px-3 py-2.5 hover:bg-amber-50", children: [_jsxs("div", { children: [_jsx("div", { className: "text-sm font-medium text-slate-800", children: item.email }), _jsx("div", { className: "text-xs text-slate-500", children: item.label })] }), _jsx("span", { className: `ml-3 shrink-0 rounded px-2 py-0.5 text-xs font-medium ${BADGE_CLS[item.type]}`, children: BADGE_LABEL[item.type] })] }, `${item.type}-${item.backupId}`))) })] }));
}
